import { Grid } from '@farewill/ui'

import { YES_NO_OPTIONS } from 'utils/enums'
import { strToBool } from 'utils/helpers'
import { BENEFICIARY_SCHEMA } from 'lib/probate/estate-questionnaire-schema'
import { Address as AddressType } from 'lib/models/address'

import ContactDetailsFields from '../../components/contact-details-fields'
import RadioGroup from '../../components/radio-group'
import { useAttributesRole } from '../../shared-contacts/roles'
import SharedPeopleSection from '../../shared-contacts/shared-people-section'

// mirrors server/src/probate/api/probate-estates/people/types.ts canBeContactedReason
const REASON_OPTIONS = [
  { label: 'Deceased', value: 'deceased' },
  { label: 'Estranged', value: 'estranged' },
  { label: 'Unable to act e.g. capacity, ex spouse', value: 'unable_to_act' },
]

const Beneficiaries = () => {
  const role = useAttributesRole({
    isMember: ({ isBeneficiary }) => !!isBeneficiary,
    given: { isBeneficiary: true },
    taken: { isBeneficiary: false },
  })

  return (
    <SharedPeopleSection
      heading="1.4 Beneficiaries"
      type="Beneficiary"
      addLabel="Add beneficiary"
      role={role}
      schema={BENEFICIARY_SCHEMA}
      renderFields={({ handleSave, values, onUnsavedAddressChange }) => {
        const canBeContacted = strToBool(values.canBeContacted as never)

        return (
          <>
            <Grid.Item span={12}>
              <RadioGroup
                label="Can this person be contacted?"
                name="canBeContacted"
                options={YES_NO_OPTIONS}
                handleSave={handleSave}
                inline
              />
            </Grid.Item>
            {canBeContacted === true && (
              <ContactDetailsFields
                address={(values.address as AddressType) ?? null}
                handleSave={handleSave}
                onUnsavedAddressChange={onUnsavedAddressChange}
              />
            )}
            {canBeContacted === false && (
              <Grid.Item span={12}>
                <RadioGroup
                  label="Reason"
                  name="canBeContactedReason"
                  options={REASON_OPTIONS}
                  handleSave={handleSave}
                  inline
                />
              </Grid.Item>
            )}
          </>
        )
      }}
    />
  )
}

export default Beneficiaries
